import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/discover-logo.png" alt="Discover Vanuatu" className="logo-image" />
          <h1>Discover Vanuatu</h1>
        </Link>
        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/categories" className="nav-link">Categories</Link>
          <Link to="/map" className="nav-link">Map</Link>
          <Link to="/favorites" className="nav-link">Favorites</Link>
          <Link to="/weather" className="nav-link">Weather</Link>
          <Link to="/tools" className="nav-link">Tools</Link>
          <a 
            href="https://business.discovervanuatu.app" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="claim-business-btn"
          >
            Claim Your Business
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
